const socialPlatforms = [
  "facebook",
  "twitter",
  "linkedin",
  "instagram",
  "youtube",
] as const;
export type SocialPlatform = typeof socialPlatforms[number];

type SocialLink = (handle: string) => string;
const facebookUrl: SocialLink = (handle) => {
  return handle.replace(/^@/, "https://www.facebook.com/");
};

const twitterUrl: SocialLink = (handle) => {
  return handle.replace(/^@/, "https://twitter.com/");
};

const instagramUrl: SocialLink = (handle) => {
  return handle.replace(/^@/, "https://instagram.com/");
};

const linkedInUrl: SocialLink = (handle) => {
  return handle.replace(/^@/, "https://linkedin.com/company/");
};

const youtubeUrl: SocialLink = (handle) => {
  return handle.replace(/^@/, "https://www.youtube.com/user/");
};

export const socialColors = {
  facebook: "#244f9f",
  twitter: "#50afed",
  linkedin: "#37589a",
  instagram: "#ff6ab0",
  youtube: "#e11a3d",
};

export const urlForHandle = (
  platform: SocialPlatform,
  handle: string
): string => {
  switch (platform) {
    case "facebook":
      return facebookUrl(handle);
    case "twitter":
      return twitterUrl(handle);
    case "linkedin":
      return linkedInUrl(handle);
    case "instagram":
      return instagramUrl(handle);
    case "youtube":
      return youtubeUrl(handle);
    default:
      console.error("unknown handle: ", handle);
      return "";
  }
};
